import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37d63855"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OTrilhaDeNavegacao",
  "data-testid": "OTrilhaDeNavegacao"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 1,
  class: "OTrilhaDeNavegacao__IconeInformacao pi pi-info-circle",
  "data-testid": "OTrilhaDeNavegacao__IconeInformacao"
}

import Breadcrumb from "primevue/breadcrumb"
  import { MenuItem } from "primevue/menuitem"

  interface Props {
    descricao?: string
    itensDaTrilha: MenuItem[]
    inicioDaTrilha: MenuItem
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTrilhaDeNavegacao',
  props: {
    descricao: null,
    itensDaTrilha: null,
    inicioDaTrilha: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Breadcrumb), {
      home: __props.inicioDaTrilha,
      model: __props.itensDaTrilha
    }, {
      item: _withCtx(({ item }) => [
        (item.to)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              custom: "",
              to: item.to
            }, {
              default: _withCtx(({ isActive, isExactActive }) => [
                (item.icon)
                  ? (_openBlock(), _createElementBlock("em", {
                      key: 0,
                      class: _normalizeClass(["OTrilhaDeNavegacao__Icon", item.icon])
                    }, null, 2))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  class: _normalizeClass(["OTrilhaDeNavegacao__QuebrarTextoGrande", {
              'active-link': isActive,
              'active-link-exact': isExactActive,
            }]),
                  title: (item.label as string)
                }, _toDisplayString(item.label), 11, _hoisted_2),
                (__props.descricao)
                  ? _withDirectives((_openBlock(), _createElementBlock("em", _hoisted_3, null, 512)), [
                      [_directive_tooltip, {
              value: __props.descricao,
              class: 'OTrilhaDeNavegacao__Tooltip',
            }]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["home", "model"])
  ]))
}
}

})